/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';
import { FileData } from '../../../../types/FileData';

export const FileCreateRequest: core.serialization.Schema<
    serializers.FileCreateRequest.Raw,
    Omit<Truvity.FileCreateRequest, 'blobId' | 'idempotencyKey'>
> = core.serialization.object({
    annotations: core.serialization.record(core.serialization.string(), core.serialization.string()).optional(),
    data: FileData.optional(),
    labels: core.serialization.record(core.serialization.string(), core.serialization.string()).optional(),
});

export declare namespace FileCreateRequest {
    export interface Raw {
        annotations?: Record<string, string> | null;
        data?: FileData.Raw | null;
        labels?: Record<string, string> | null;
    }
}
